<div class="center-layout">
	<h2>{{ "i18n.unauthorized.title" | translate }}</h2>
	<h3>{{ "i18n.unauthorized.text" | translate }}</h3>
</div>
